module.exports = __webpack_public_path__ + "img/icon_product13.1c02305d.png";